import {Component, ElementRef, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Router} from "@angular/router";
import {AlertService} from "../../../shared/services/alert.service";
import {ContactUsService} from "../../../shared/services/contact-us.service";
import {Meta, Title} from "@angular/platform-browser";


@Component({
    selector: 'app-ims',
    templateUrl: './ims.component.html',
    styleUrls: ['./ims.component.scss']
})
export class ImsComponent implements OnInit {
    @ViewChild('contactFormModal') contactFormModal!: TemplateRef<any>;
    @ViewChild('videoElement') videoElement!: ElementRef<HTMLVideoElement>;
    isModalOpen = false;
    contactForm: FormGroup;
    submitted: any = false;
    submitting: any = false;
    successMessage: string;
    modules = [
        {text: 'Admissions'},
        {text: 'Finance'},
        {text: 'Attendance'},
        {text: 'Communication'},
        {text: 'Reporting'},
        {text: 'Examination'},
        {text: 'Scheduling'},
        {text: 'User Security'},
    ];

    centralized = [
        {text: 'Student Tracking'},
        {text: 'Exam Management'},
        {text: 'Payment Gateways'},
        {text: 'Fee Management'},
        {text: 'Documents Automation'},
        {text: 'Modules Integration'},
    ];

    features = [
        {text: 'User and Security'},
        {text: 'Finance'},
        {text: 'Student Control'},
        {text: 'Admission'},
        {text: 'Virtual Learning'},
        {text: 'Multi-Branches'},
    ];

    benefits = [
        {icon: 'assets/img/landing-new/ims/benefits/benefits1.png', text: 'Franchise Management Module (FMM)', content: 'An FM Module is a software system designed to assist franchisors in managing franchise operations, ensuring consistency, compliance, and effective communication.\n'},
        {icon: 'assets/img/landing-new/ims/benefits/benefits5.png', text: 'Management Administrative Module (MAM)', content: 'The SM Module is a software that streamlines administrative processes, enhances communication, and provides a centralized platform for managing student information and academic records. \n'},
        {icon: 'assets/img/landing-new/ims/benefits/benefits2.png', text: 'Student Management Module (SMM)', content: 'The Management Administrative Module is made to handle and simplify several administrative duties and procedures inside a company or an institute.'},
    ];

    whyChoose = [
        {
            header: 'Easy To Use',
            text: 'Volmint Technologies created products to minimize efforts and maximize productivity. We are giving extra care to user experience and user interface that helps to develop user-friendly software that is easily accessible.'
        },
        {
            header: 'Cloud-Based System',
            text: 'We use several firewalls to create secure servers. Robust backbone connectivity with the newest cloud-based technologies completely integrated to create a better and more secure work ethic.'
        },
        {
            header: '24/7 Availability',
            text: 'Access the Institute Management System using a computer or mobile device from any location on the Internet. restrictions based on roles and IP addresses that help to solve issues within very little time.'
        },
        {
            header: 'Automated Document Generation',
            text: 'Reduce time and effort by generating institute management system project documentation systems automatically. This ensures the timely and accurate creation of necessary paperwork.'
        },
        {
            header: 'Quick Assistance & Communication',
            text: 'Rapid assistance is available by phone, email, and video conference. To create efficiency, you will be notified with auto-generated mail, SMS, or WhatsApp messages, ensuring timely updates.'
        },
        {
            header: 'Custom Affordable Products',
            text: 'Being a renowned IT company, we offer customizable options to meet the requirements of every business. The cost of products is affordable yet we do not compromise on quality or performance.'
        },
    ];

    offerings = [
        {
            text: 'Free Lifetime Maintenance'
        },
        {
            text: 'Tailored Assistance'
        },
        {
            text: 'Updates and Upgrades'
        },
        {
            text: 'Discounts'
        },
        {
            text: 'Contributions'
        },
        {
            text: 'Training'
        },
        {
            text: 'Tools Integration'
        },
        {
            text: 'Counseling'
        },
        {
            text: 'Fast Solution'
        },
        {
            text: 'Free Server'
        },
    ];

    constructor(
        public fb: FormBuilder,
        public alertService: AlertService,
        private router: Router,
        private contactService: ContactUsService,
        private meta: Meta,
        private title: Title,
    ) {
    }

    ngOnInit(): void {
        this.refresh();
        this.updateMetaTags()
    }

    refresh() {
        this.contactForm = this.fb.group({
            name: ['', Validators.required],
            email: ['', [Validators.required, Validators.email]],
            contact: [''],
            // subject: ['', Validators.required],
            message: ['', Validators.required]
        });
    }

    openModal() {
        this.isModalOpen = true;
    }

    closeModal() {
        this.isModalOpen = false;
    }

    handleOverlayClick(event: MouseEvent) {
        const target = event.target as HTMLElement;
        if (!target.closest('.modal-dialog')) {
            this.closeModal();
        }
    }

    submit() {
        this.submitted = true;
        if (!this.contactForm.valid) {
            return;
        }
        if (this.submitted) {
            const params = {
                'name': (this.contactForm && this.contactForm.getRawValue() && this.contactForm.getRawValue().name) ? this.contactForm.getRawValue().name : '',
                'email': (this.contactForm && this.contactForm.getRawValue() && this.contactForm.getRawValue().email) ? this.contactForm.getRawValue().email : '',
                'contact': (this.contactForm && this.contactForm.getRawValue() && this.contactForm.getRawValue().contact) ? this.contactForm.getRawValue().contact : '',
                // 'subject': (this.contactForm && this.contactForm.getRawValue() && this.contactForm.getRawValue().subject) ? this.contactForm.getRawValue().subject : '',
                'message': (this.contactForm && this.contactForm.getRawValue() && this.contactForm.getRawValue().message) ? this.contactForm.getRawValue().message : '',
            };
            this.contactService.create(params).subscribe(data => {
                this.successMessage = 'Your form has been submitted successfully!';
                this.submitted = false;
                this.contactForm.patchValue({
                    'name': '',
                    'email': '',
                    'contact': '',
                    // 'subject': '',
                    'message': ''
                });
            }, error => {
                this.submitting = false;
                this.submitted = false;
                if (error && error['error'] && error['error']['errors'] && error['error'].hasOwnProperty('errors')) {
                    if (error['error']['errors'].email && error['error']['errors'].email.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].email[0]);
                        return;
                    }
                    if (error['error']['errors'].name && error['error']['errors'].name.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].name[0]);
                        return;
                    }
                    if (error['error']['errors'].contact && error['error']['errors'].contact.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].contact[0]);
                        return;
                    }
                    // if (error['error']['errors'].subject && error['error']['errors'].subject.length > 0) {
                    //     this.alertService.showErrors(error['error']['errors'].subject[0]);
                    //     return;
                    // }
                    if (error['error']['errors'].message && error['error']['errors'].message.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].message[0]);
                        return;
                    }
                }
            });
        }
    }

    playVideo() {
        const video = this.videoElement.nativeElement;
        const thumbnail = document.getElementById('video-thumbnail');
        if (video) {
            video.classList.remove('d-none');
            video.play();
            if (thumbnail) {
                thumbnail.style.display = 'none';
            }
            const playButton = document.querySelector('.play-button');
            if (playButton) {
                playButton.classList.add('d-none');
            }
        }
    }

    goTo(url) {
        this.router.navigateByUrl(url);
    }


    updateMetaTags() {
        this.title.setTitle('Volmint’s IMS - A Complete Institute Management System');
        this.meta.updateTag({name: 'description', content: 'Manage your institute\'s administrative tasks, student tracking, and improve efficiency and more smartly with Volmint’s Institute Management System'});
        this.meta.updateTag({name: 'keyword', content: 'school management system, institute management system, institution management system, institute student management system, exam management system, institute management software, ims software, computer institute management system, coaching institute management system, education institute management system, educational institute management system'});

    }
}
